<template>
  <v-menu
    v-model="showMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
    :disabled="readonly"
    :left="menuLeft"
  >
    <template v-slot:activator="{ on, attrs }">
      <custom-label v-if="label" :item-field-name="label" />
      <v-text-field
        :readonly="readonly"
        :class="{ 'small-input': small }"
        style="font-size: 14px"
        hide-details="auto"
        rounded
        filled
        :background-color="$vuetify.theme.themes.light.inputBackgroundColor"
        dense
        v-mask="dateMask"
        v-model="dateString"
        prepend-inner-icon="mdi-calendar"
        v-bind="$attrs"
        v-on="on"
        @blur="onDateStringChange"
        @keydown.enter="
          () => {
            onDateStringChange();
            showMenu = false;
          }
        "
      ></v-text-field>
    </template>
    <v-date-picker
      :type="isMonth ? 'month' : 'date'"
      :max="max"
      :min="min"
      v-model="valueProxy"
      @input="showMenu = false"
    />
  </v-menu>
</template>

<script>
import moment from 'moment';
import customLabel from '@/components/customFormLabel/customLabel';
export default {
  components: {
    customLabel,
  },
  props: {
    value: {
      type: [String, Date],
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    max: {
      type: String,
      default: null,
    },
    min: {
      type: String,
      default: null,
    },
    small: {
      Boolean,
      default: false,
    },
    displayDateFormat: {
      type: String,
      default: 'YYYY-MM-DD',
    },
    isMonth: {
      type: Boolean,
      default: false,
    },
    menuLeft: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showMenu: false,
      dateString: null,
    };
  },
  computed: {
    valueProxy: {
      get() {
        if (this.value) return moment(this.value).format('YYYY-MM-DD');
        else return this.value;
      },
      set(v) {
        return this.$emit('input', v ? moment(v).toDate() : null);
      },
    },
    dateMask() {
      return this.displayDateFormat.replace(/[a-zA-Z]/g, '#');
    },
  },
  watch: {
    value: {
      handler(v) {
        this.dateString = v ? moment(v).format(this.displayDateFormat) : null;
      },
      immediate: true,
    },
  },
  methods: {
    onDateStringChange() {
      if (!this.dateString) this.valueProxy = null;
      const date = moment(this.dateString, this.displayDateFormat);
      if (date.isValid()) {
        if (date.format('YYYYMMDD') !== moment(this.value).format('YYYYMMDD')) {
          this.valueProxy = date;
        }
      } else {
        this.dateString = this.value ? moment(this.value).format(this.displayDateFormat) : null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-text-field input {
  padding: 5px 0;
}
</style>
